export abstract class eGENA_ProblemKategorie {
	public a : boolean = false;
	public b : boolean = false;
	public c : boolean = false;
	public d : boolean = false;
	public e : boolean = false;

	constructor(auchEtwasMitProblemKategorien : eGENA_ProblemKategorie | any | undefined) {
		if (auchEtwasMitProblemKategorien != undefined) {
			if (auchEtwasMitProblemKategorien instanceof eGENA_ProblemKategorie) {
				this.a = auchEtwasMitProblemKategorien.a;
				this.b = auchEtwasMitProblemKategorien.b;
				this.c = auchEtwasMitProblemKategorien.c;
				this.d = auchEtwasMitProblemKategorien.d;
				this.e = auchEtwasMitProblemKategorien.e;
			}
			else {
				if ('a' in auchEtwasMitProblemKategorien)
					this.a = auchEtwasMitProblemKategorien.a;
				if ('b' in auchEtwasMitProblemKategorien)
					this.b = auchEtwasMitProblemKategorien.b;
				if ('c' in auchEtwasMitProblemKategorien)
					this.c = auchEtwasMitProblemKategorien.c;
				if ('d' in auchEtwasMitProblemKategorien)
					this.d = auchEtwasMitProblemKategorien.d;
				if ('e' in auchEtwasMitProblemKategorien)
					this.e = auchEtwasMitProblemKategorien.e;
			}
		}
	}

	public problemkategorienAsArray() : string[] {
		let array : string[] = [];
		if (this.a) array.push('A');
		if (this.b) array.push('B');
		if (this.c) array.push('C');
		if (this.d) array.push('D');
		if (this.e) array.push('E');
		return array;
	}

	public static problemkategorienAsString(that : eGENA_ProblemKategorie) : string {
		let problemKategorien : string = "";
		if (that.a)
			problemKategorien += 'A';
		if (that.b)
			problemKategorien += 'B';
		if (that.c)
			problemKategorien += 'C';
		if (that.d)
			problemKategorien += 'D';
		if (that.e)
			problemKategorien += 'E';

		return problemKategorien;
	}


	/** Falls in `anderesDing` eines der Probleme den Wert `true` hat, dann ist diese Problemkategorie auch für mich gültig
	 * 
	 * @param anderesDing 
	 */
	deineProblemeSindAuchMeineProbleme(anderesDing : eGENA_ProblemKategorie) {
		if (anderesDing.a)
			this.a = true;
		if (anderesDing.b)
			this.b = true;
		if (anderesDing.c)
			this.c = true;
		if (anderesDing.d)
			this.d = true;
		if (anderesDing.e)
			this.e = true;
	}

	/** Falls in `dingeMitProblemkategorie` bei einem der Elemente eines der Probleme den Wert `true` hat, dann ist diese Problemkategorie auch für mich gültig.
	 *  Die Array-Variante von [[deineProblemeSindAuchMeineProbleme]]
	 * @param anderesDing 
	 */
	eureProblemeSindAuchMeineProbleme(dingeMitProblemkategorie : eGENA_ProblemKategorie[]) {
		for (const ding of dingeMitProblemkategorie)
			this.deineProblemeSindAuchMeineProbleme(ding);
	}
	
	/** Samelt alle Problemkategorien in einem fortlaufenden String aus Großbuchstaben zusammen und umschließt ihn dann mit eckigen Klammern.
	 *  Z.B. "[ABC]"
	 *  
	 *  @returns Ein String nach obiger Definition
	 */
	toString() : string {
		let problemKategorien : string = eGENA_ProblemKategorie.problemkategorienAsString(this);

		if (problemKategorien.length > 0)
			problemKategorien = '[' + problemKategorien + ']';
		else
			problemKategorien = "";

		return problemKategorien;
	}
}


// WEBPACK FOOTER //
// ./src/visionet/ProblemKategorieABCDE.ts